// add country codes here for e.g {"uk": ["uk", "ir", "no"], "at": ["at", "de"]}
const AutoCompleteCountryMap: { [countryCode: string]: string[] } = {
  dxb: ["no"]
};
export default AutoCompleteCountryMap;
